module.exports = __webpack_public_path__ + "img/Yoga_002.7c9528f.jpg";